import "./multiCarousel.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const MultiCarousel = (props) => {

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 5,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
            slidesToSlide: 2 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

  return (
    <div className="container container-multicarousel">
        
        <Carousel className="multi-carousel"
        swipeable={true}
        draggable={true}
        showDots={true}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={false}
        // autoPlay={this.props.deviceType !== "mobile" ? true : false}
        autoPlay={false}
        autoPlaySpeed={1000}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={500}
        containerClass="container-multicarousel"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        deviceType={"desktop"}
        dotListClass="custom-dot-list-style"
        itemClass=""
        >
            {props.data.items.map((item, index)=> {
                return(<div  key={index} data-promo={"rolling-banner-"+item.description} className="multi-item"  style={{backgroundImage:`url(${item.url})`}}>
                   <a href={item.description} target="_blank" rel="noreferrer">
                        <div className="ref-multi">

                        </div>
                   </a>
                </div>)
            })}

            {/* <div className=" multi-item"></div>
            <div className=" multi-item"></div>
            <div className=" multi-item"></div>
            <div className=" multi-item">Item 5</div>
            <div className=" multi-item">Item 6</div>
            <div className=" multi-item">Item 7</div> */}
        </Carousel>

    </div>
  );
};

export default MultiCarousel;
